module.exports = __webpack_public_path__ + "static/img/ydyl2.0951ed5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/ydyl2.jpg
// module id = QHpy
// module chunks = 0